

































import Vue from 'vue';
// not going to refactor and type the VueSelect
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { IStyleObject } from '../../../common/interfaces/index.interface';
import { IOldCustomSelectOption } from '../../../common/interfaces/shared.interface';

interface ICustomSelectComponent {
  OpenIndicator: { render: (arg: (el: string, options: { class: string }) => HTMLElement) => unknown };
  value: IOldCustomSelectOption | null;
}

export default Vue.extend({
  components: { VueSelect },
  data(): ICustomSelectComponent {
    return {
      OpenIndicator: {
        render: (createElement): HTMLElement => createElement(`span`, { class: `custom-select__icon` }),
      },
      value: null,
    };
  },
  computed: {
    textCenter(): IStyleObject {
      if(this.centerTextAlign) {
        return { textAlign: `center`, width: `100%` };
      }
      return {};
    },
  },
  props: {
    centerTextAlign: {
      default: false,
      type: Boolean,
    },
    identifier: {
      default: ``,
      type: String,
    },
    options: {
      required: true,
      type: Array as () => IOldCustomSelectOption[],
    },
    selected: {
      default: null,
      type: Number,
    },
  },
  methods: {
    setValue(): void {
      this.value = this.options[this.options.findIndex(option => option.code === this.selected)];
    },
  },
  watch: {
    options: {
      handler(): void {
        if(this.selected) {
          this.setValue();
        } else {
          [this.value] = this.options;
        }
      },
      immediate: true,
    },
    selected: {
      handler(): void {
        this.setValue();
      },
    },
  },
});
